export default "__VITE_ASSET__f098ca10__"